import { useEffect, useState } from 'react';
import { messageCallbackType, useStompClient } from 'react-stomp-hooks';

import localStorageStore from '../store/LocalStorageStore';
import { GameTable } from '../store/state/GameTable';
import tableStore from '../store/TableStore';
import websocketStore from '../store/WebsocketStore';

export const useWebsocketSubscription = (
  destination: string,
  onMessage: messageCallbackType,
  tableId?: string,
  enabled = true,
): void => {
  if (!enabled) return;

  const stompClient = useStompClient();

  const [table, setTable] = useState<GameTable>();

  useEffect(() => {
    if (tableId) {
      tableStore.findActiveTableById(tableId).then(setTable);
    }
  }, [tableId]);

  useEffect(() => {
    if (
      (!tableId || (table && !table.deleted)) &&
      stompClient?.connected &&
      tableStore.isActiveTablesInitialized
    ) {
      if (websocketStore.addDestination(destination)) {
        const subscription = stompClient.subscribe(destination, onMessage, {
          Authorization: localStorageStore.getToken(),
        });
        return () => {
          websocketStore.removeDestination(destination);
          if (stompClient?.webSocket?.readyState === WebSocket.OPEN) {
            subscription.unsubscribe();
          }
        };
      }
    }
  }, [
    table,
    table?.deleted,
    tableStore.viewingModalWindowTableId,
    tableStore.isActiveTablesInitialized,
    stompClient,
    stompClient?.connected,
    destination,
    enabled,
  ]);
};
